import getApiClient from "./../../../../shared/api";

export const FETCH_CHARACTER_PROPS = "FETCH_CHARACTER_PROPS";

export function fetchCharacterProps(filmId, characterId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_CHARACTER_PROPS,
      payload: getApiClient().get(`/film/${filmId}/character/${characterId}/props`)
    });
  };
}
